var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.5 10.19H17.61C15.24 10.19 13.31 8.26 13.31 5.89V3C13.31 2.45 12.86 2 12.31 2H8.07C4.99 2 2.5 4 2.5 7.57V16.43C2.5 20 4.99 22 8.07 22H15.93C19.01 22 21.5 20 21.5 16.43V11.19C21.5 10.64 21.05 10.19 20.5 10.19Z",
    fill: "#009FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7997 2.20999C15.3897 1.79999 14.6797 2.07999 14.6797 2.64999V6.13999C14.6797 7.59999 15.9197 8.80999 17.4297 8.80999C18.3797 8.81999 19.6997 8.81999 20.8297 8.81999C21.3997 8.81999 21.6997 8.14999 21.2997 7.74999C19.8597 6.29999 17.2797 3.68999 15.7997 2.20999Z",
    fill: "#009FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2804 14.72C11.9904 14.43 11.5104 14.43 11.2204 14.72L10.5004 15.44V11.25C10.5004 10.84 10.1604 10.5 9.75043 10.5C9.34043 10.5 9.00043 10.84 9.00043 11.25V15.44L8.28043 14.72C7.99043 14.43 7.51043 14.43 7.22043 14.72C6.93043 15.01 6.93043 15.49 7.22043 15.78L9.22043 17.78C9.23043 17.79 9.24043 17.79 9.24043 17.8C9.30043 17.86 9.38043 17.91 9.46043 17.95C9.56043 17.98 9.65043 18 9.75043 18C9.85043 18 9.94043 17.98 10.0304 17.94C10.1204 17.9 10.2004 17.85 10.2804 17.78L12.2804 15.78C12.5704 15.49 12.5704 15.01 12.2804 14.72Z",
    fill: "#009FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDownload);
export default __webpack_public_path__ + "static/media/document-download.17b6e3ce23b6b977b4eb956553837ab6.svg";
export { ForwardRef as ReactComponent };